import React from "react";
import Navbaruserprofile from "../../Components/Navbaruserprofile/Navbaruserprofile";
import AddMultiUsers from '../../Components/AddMultiUsers/AddMultiUsers';

function AdvisorFirmMultiUserScreen() {

    return (
        <>
            <Navbaruserprofile />
            <div className="container">
                <main className="profile-content">
                    <AddMultiUsers />
                </main>
            </div>
        </>
    );
}

export default AdvisorFirmMultiUserScreen;
